import { useQuery } from '@apollo/client'
import { PageMainWrapper } from 'components/dpc/style'
import {
  Hero,
  Main,
  SatisfactionSurvey,
} from 'components/dpc/TrainingSpace'
import Separator from 'components/landing/Separator'
import DpcLayout from 'components/layouts/DpcLayout'
import styled from 'styled-components'
import { colors, sizes } from 'theme'

import { USER } from '@/graphql/queries/user'

const TrainingSpace = () => {
  const userQuery = useQuery(USER)
  const hasAccess = Boolean(userQuery?.data?.me?.dpcAccess)
  const hasCompleted = userQuery?.data?.me?.dpcAccess?.isCompleted

  return (
    <DpcLayout>
      <Wrapper>
        <Hero />
        <Separator />
        { hasAccess && <Main /> }
        { hasCompleted && <SatisfactionSurvey /> }
      </Wrapper>
    </DpcLayout>
  )
}

const Wrapper = styled(PageMainWrapper)`
  padding: ${sizes.heroesPaddingTop} 1rem 4rem;
  color: ${colors.darkBlue};

  h1 {
    font-weight: 900;
    text-align: left;

    em {
      font-weight: 900;
      color: ${colors.purple};
    }
  }

  h3 {
    margin-top: 4rem;
  }

  h4 {
    margin-top: 3rem;
    font-size: 1.25rem;
    font-weight: 700;
  }

  em {
    font-weight: bold;
  }

  article {
    text-align: left;
  }

  a {
    width: fit-content;
  }

  ${Separator} {
    margin: 3rem auto 0;
  }

  .italic {
    font-style: italic;
  }
`

export default TrainingSpace
